import { isEmpty, get } from 'lodash';
import snsWebSdk from '@sumsub/websdk';
import { always } from 'ramda';

import app from '../../scripts/app';
import { getSearchParams } from '../../scripts/utils';
import template from './user-identification.jade';

app.directive('cianAfUserIdentification', ['userService', 'logger', 'config', function(userService, logger, config) {
    return {
      template,
      scope: {},
      bindToController: {},
      controller: function($rootScope, userIdentificationService) {
        'ngInject';

        this.isSelectPageSkipped = () => {
          return userIdentificationService.getTaskList().length <= 1;
        };


        this.getBackUrl = () => {
          let url = window.location.href;
          let queryParams = getSearchParams();

          const id = userIdentificationService.getDraftId();

          if (id && (!queryParams || !queryParams.id)) {
            url+= (isEmpty(queryParams) ? '?' : '&') + `id=${id}`;
          }

          return url;
        };

        // В FF и Safari нельзя отправить пользователя на ту же страницу, что уже открыта.
        // Поэтому перезагружаем черновик, если открыт именно он.
        this.handleBackUrl = ($event) => {
          userIdentificationService.setIsVisible(false);
          userIdentificationService.setIsSelectPageVisible(!this.isSelectPageSkipped());
        };

        this.isLoading = false;

        const onMessage = (messageType, payload) => {
          // Ошибка!
          if (messageType === 'idCheck.onError') {
            userIdentificationService.setIsVisible(false);
            userIdentificationService.getCompleteCallback('error');
            logger.error(payload.error, payload);
            return;
          }
          // Пользователь загрузил все документы
          if (['idCheck.onApplicantSubmitted', 'idCheck.onApplicantResubmitted'].indexOf(messageType) >= 0) {
            // Только один раз отправляем колбэк, самсаб иногда двоит
            if (!this.isLoading) {
              userIdentificationService.getCompleteCallback('success');
            }
            this.isLoading = true;
            userIdentificationService.setIsVisible(false);
          }
        };

        /**
         * Если все нужное из sumsub-а загрузилось, то вызываем отрисовку iframe с идентификацией
         */
        const sumsubApiUrl = config.get('sumsub.apiUrl');

        const snsWebSdkInstance = snsWebSdk
        .Builder(sumsubApiUrl, 'web_identification')
        .withAccessToken(userIdentificationService.getAccessToken(), always(undefined))
        .withConf({
          lang: 'ru',
          onMessage,
        })
        .build();

        snsWebSdkInstance.launch('#idensic');
      },
      controllerAs: 'userIdentificationCtrl',
    };
  }]);
